export default __webpack_public_path__ + "static/media/miscellaneous-bg.c5a3fa49.webp";